import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const LivejournalScaleMedium = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.8805 0.5L8.16005 2.78255C9.45966 2.21878 10.8614 1.92841 12.278 1.9295C18.008 1.9295 22.6535 6.5915 22.6535 12.3395C22.6535 18.0905 18.008 22.7525 12.278 22.7525C6.548 22.7525 1.9025 18.092 1.9025 12.341C1.9025 10.8677 2.22895 9.48734 2.78159 8.21623L11.2199 16.6755L11.219 16.6776L11.2205 16.6761L11.2199 16.6755C12.2615 14.2522 14.1819 12.3129 16.595 11.2476L8.16049 2.78763L8.15599 2.78613C5.74316 3.85059 3.82328 5.78968 2.78289 8.21289L0.5 5.924C1.54213 3.50002 3.46499 1.56162 5.8805 0.5ZM2.78289 8.21289L2.783 8.213L2.78159 8.21623L2.78149 8.21613L2.78289 8.21289ZM14.0765 17.2907C14.6821 15.8831 15.7978 14.7568 17.1995 14.1377L18.017 18.1097L14.0765 17.2907Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Livejournal'
);
export default LivejournalScaleMedium;
